import { FC, useEffect, useState } from 'react'
import { getPlayerId } from '../controllers/stats'
import generateGlobalPerformanceMessage from '../util/generateGlobalPerformanceMessage'
import getGlobalPerformance from '../util/getGlobalPerformance'
import getPerformanceIcon from '../util/getPerformanceIcon'

type Props = {
	puzzleNumber: number
	time: number
	onPerformanceChange?: (performance: string | null) => void
}

const GlobalPerformance: FC<Props> = ({ puzzleNumber, time, onPerformanceChange }) => {
	const [globalPerformance, setGlobalPerformance] = useState<string | null>(null)

	useEffect(() => {
		let isRequestStale = false

		if (time <= 0) {
			setGlobalPerformance(null)
			return () => {
				isRequestStale = true
			}
		}

		getGlobalPerformance(puzzleNumber, time).then(performance => {
			if (!isRequestStale) {
				setGlobalPerformance(performance)
			}
		})

		return () => {
			isRequestStale = true
		}
	}, [puzzleNumber, time])

	const performanceIcon = globalPerformance ? getPerformanceIcon(globalPerformance) : null
	const performanceMessage = globalPerformance
		? generateGlobalPerformanceMessage(getPlayerId(), puzzleNumber)
		: null

	useEffect(() => {
		onPerformanceChange?.(globalPerformance)
	}, [globalPerformance, onPerformanceChange])

	if (!globalPerformance || !performanceIcon) {
		return null
	}

	return (
		<div className="board__message4">
			<div className="board__message4-rank">
				<picture className="board__message4-trophy">
					<source srcSet={performanceIcon.webp} type="image/webp" />
					<img
						src={performanceIcon.gif}
						alt={performanceIcon.alt}
						width="55"
						height="55"
					/>
				</picture>
				<span
					className={`board__message4-highlight board__message4-highlight--${performanceIcon.rank}`}
				>
					{globalPerformance.toUpperCase()}
				</span>
			</div>
			<div className="board__message4-subtitle">{performanceMessage}</div>
		</div>
	)
}

export default GlobalPerformance
